import { op } from "libs/transaction";
import { createAction } from "./action";
import * as ops from "libs/operations";
import { WebPushSubscription } from "libs/schema";
import { PermissionError } from "../../errors";

/* -------------------------------------------------------------------------------------------------
 *  subscribeToPushNotifications
 * -------------------------------------------------------------------------------------------------
 */

type SubscribeToPushNotificationsProps = {
  subscriptionId: string;
  ownerOrganizationId: string;
  subscription: WebPushSubscription;
};

export const subscribeToPushNotifications = createAction<SubscribeToPushNotificationsProps>(
  "userPushNotificationSubscription.subscribeToPushNotifications",
  {
    operations: async (props, context) => {
      return ops.userPushNotificationSubscription.createPushNotificationSubscription({
        id: props.subscriptionId,
        userId: context.currentUserId,
        ownerOrganizationId: props.ownerOrganizationId,
        subscription: props.subscription,
      });
    },
    authorize: async () => {
      // Users are permitted to create their own push subscription records, and the current implementation
      // with `context.currentUserId` ensures it, so no authorization is necessary.
    },
  },
);

/* -------------------------------------------------------------------------------------------------
 *  unsubscribeFromPushNotifications
 * -------------------------------------------------------------------------------------------------
 */

type UnsubscribeFromPushNotificationsProps = {
  subscriptionId: string;
};

export const unsubscribeFromPushNotifications = createAction<UnsubscribeFromPushNotificationsProps>(
  "userPushNotificationSubscription.unsubscribeFromPushNotifications",
  {
    operations: async (props) => {
      return op.delete("user_push_notification_subscriptions", { id: props.subscriptionId });
    },
    authorize: async (props, context) => {
      const [subscription] = await context.environment.loader.getRecord(
        "user_push_notification_subscriptions",
        props.subscriptionId,
      );

      if (subscription && subscription.user_id !== context.currentUserId)
        throw new PermissionError("The subscription does not belong to the user");
    },
  },
);

export const actions = {
  subscribeToPushNotifications,
  unsubscribeFromPushNotifications,
};
